/**
 * Onboarding Page
 */
import {
	Card,
	CardHeader,
	CardTitle,
	CardDescription,
	CardContent,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/ui/link";
import { ArrowRight } from "lucide-react";
import { useTranslations } from "@/hooks/use-translations";

export function OnboardingPage() {
	const t = useTranslations("onboarding");

	return (
		<div className="min-h-screen bg-bg-canvas flex items-center justify-center p-6">
			<div className="w-full max-w-lg">
				<Card>
					<CardHeader className="text-center">
						<CardTitle className="text-2xl">{t("welcome")}</CardTitle>
						<CardDescription>{t("letsGetStarted")}</CardDescription>
					</CardHeader>
					<CardContent className="space-y-4">
						<p className="text-text-secondary text-center">
							{t("completeProfile")}
						</p>
						<Button asChild className="w-full">
							<Link href="/">
								{t("getStarted")}
								<ArrowRight size={16} />
							</Link>
						</Button>
					</CardContent>
				</Card>
			</div>
		</div>
	);
}
